module.exports = __webpack_public_path__ + "static/media/logo.9b725664.png";


//////////////////
// WEBPACK FOOTER
// ./src/branding/current/logo.png
// module id = 19
// module chunks = 0